import React, {Component} from 'react';
import "./Loading.css";
import {ProgressSpinner} from "primereact/progressspinner";
// import {Circle} from 'better-react-spinkit';

export default class Loading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            label: this.props.label || ""

        };
    }

    render() {
        return (
            <div id="loadingPosmarket" className="loadingPosmarket">
                <div className="loading">

                </div>
                <div className="loadingContent">
                    <div className="spinner">
                        <ProgressSpinner
                            variant="indeterminate"
                            disableShrink
                            style={{
                                color: 'blue',
                                animationDuration: '550ms',
                            }}
                            size={50}
                            thickness={7}
                        />
                    </div>

                    <div className="loadingText">
                        {this.state.label}
                    </div>
                </div>
            </div>
        );
    }
}